<template>
	<div class="email form-group" :class="{ 'is-empty': empty, 'is-disabled': readonly }" :data-element="element.id"
		:title="readonly ? $t('app.common.readonly') : ''">
		<div class="d-flex justify-content-between align-items-center">
			<label class="element-label" :class="classes('title')" :title="required ? trans('buttons.required') : ''">
				<span v-html="macro(label)"></span>
				<small v-if="required" class="required">*</small>
			</label>
			<div v-if="fieldVisibleOnlyInPreview" class="app--engagement-advisor-preview-icon ms-2">
				<app-icon :title="trans('visibility.field.preview')" value="eye" type="fas" class="fa-sm" />
			</div>
		</div>
		<div class="input-group">
			<input type="email" class="form-control" maxlength="128" v-model="value" @blur="update"
				:class="classes('input')" :data-label="label" :disabled="readonly" :readonly="readonly"
				:required="required">
			<div class="input-group-text" :class="classes('input')">
				<app-icon value="email"></app-icon>
			</div>
		</div>
		<div class="invalid-feedback" :for="label" :class="{ 'd-block': !valid }">
			<span v-if="!valid">{{ $t('validation.mandatory') }}</span>
		</div>
		<small class="form-text" :class="classes('description')">
			<span v-if="description" v-html="macro(description)"></span>&nbsp;
		</small>
	</div>
</template>

<script>
import store from '../../store'

export default {
	props: {
		definition: { type: Object, required: true },
		element: { type: Object, required: true },
	},
	computed: {
		description() {
			return typeof this.definition.description == 'string' ? this.definition.description : null
		},
		empty() {
			return this.value == ''
		},
		saved() {
			return this.element && this.element.value != null && this.element.value != ''
		},
		label() {
			return this.definition.title
		},
		readonly() {
			return store.getters.readonly(this.definition, this.saved)
		},
		required() {
			return this.options('required') == true
		},
		valid() {
			return !(this.element && this.element.valid === false)
		},
		fieldVisibleOnlyInPreview() {
			return this.definition.print_visibility == 'preview' && store.state.preview == true && store.state.complete == false
		}
	},
	data() {
		return { value: '' }
	},
	watch: {
		'element.value': {
			immediate: true,
			handler(value) {
				this.value = value && typeof value == 'string' ? value.toString() : ''
			}
		}
	},
	methods: {
		classes(index) {
			return store.getters['classes'](index)
		},
		macro(value) {
			return store.getters['macro'](value)
		},
		options(value) {
			return store.getters['options'](this.definition, value)
		},
		update(event) {
			if (this.element.value === null && this.empty) {
				this.value = '';
				return
			}
			if (!this.readonly && this.$validate(event) && event.target.value !== this.element.value) {
				let gk = this.element.group + '|' + this.definition.group
				store.commit('QUEUE', { id: this.element.id, group: gk, value: this.value })
			}
		},
		trans(key) {
			let trans = store.getters.trans(key)
			return trans ? trans : this.$t('front.' + key)
		}
	}
}
</script>
